import React from 'react';
import { CommonEmbed } from 'components/common/CommonEmbed';

export const Notice: React.FC = () => {
    return <CommonEmbed title="공지사항" path="/notice" />;
};
